import { c as _c } from "react-compiler-runtime";
import { collaborationSidebarStateFollowerReady } from '../../store/collaborationSidebarState';
import { useStateValue } from '../../store/collaborationSidebarProvider';

/**
 * Promise-based accessor intended for scenarios where it is not practical to
 * source this data through the React hook (e.g. imperative code paths outside
 * of a component).
 *
 * Prefer `useCollaborationSidebarHasUnrecoverableError` where possible — the
 * hook re-renders as the underlying state changes, while this function returns
 * a one-time snapshot of the state.
 *
 * Rejects if no leader responds within the follower-ready timeout.
 */
export const getCollaborationSidebarHasUnrecoverableError = async () => {
  var _follower$getState$ha;
  const follower = await collaborationSidebarStateFollowerReady();
  return {
    hasUnrecoverableError: (_follower$getState$ha = follower.getState().hasUnrecoverableError) !== null && _follower$getState$ha !== void 0 ? _follower$getState$ha : false
  };
};
export const useCollaborationSidebarHasUnrecoverableError = () => {
  "use memo";

  var _useStateValue;
  const $ = _c(2);
  const hasUnrecoverableError = (_useStateValue = useStateValue("hasUnrecoverableError")) !== null && _useStateValue !== void 0 ? _useStateValue : false;
  let t0;
  if ($[0] !== hasUnrecoverableError) {
    t0 = {
      hasUnrecoverableError
    };
    $[0] = hasUnrecoverableError;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};